import { _ } from '../../lib';
export const getInternalValue = (propVal) => {
    if (_.isArray(propVal)) {
        return propVal;
    }
    else if (propVal == null) {
        return [];
    }
    return [propVal];
};
export const getValuesAfterClick = (values, selected, clickedItem, modifier) => {
    if (modifier == 1) {
        return [clickedItem];
    }
    if (modifier == 2) {
        let value = null;
        value = selected.includes(clickedItem)
            ? selected.filter(x => x != clickedItem)
            : selected.concat(clickedItem);
        return value;
    }
    let latest_index = -1;
    if (selected.length >= 1) {
        latest_index = values.indexOf(_.last(selected));
    }
    const new_index = values.indexOf(clickedItem);
    const iterator = new_index > latest_index ? 1 : -1;
    const new_indices = _.range(latest_index, new_index + iterator, iterator);
    const value = _.uniq(_.concat(selected, new_indices.map(x => values[x])));
    return value;
};
export const resolvePendingDeltas = (pendingDeltas, value, values, isMulti) => {
    if (pendingDeltas.length == 0) {
        return undefined;
    }
    const deltasGrouped = [];
    _.forEach(pendingDeltas, delta => {
        const last = deltasGrouped.slice(-1)[0];
        if (last?.shift == delta.shift) {
            last.delta += delta.delta;
        }
        else {
            deltasGrouped.push(delta);
        }
    });
    let selected_items = value;
    _.forEach(deltasGrouped, delta => {
        selected_items = delta.shift
            ? selectDelta(selected_items, delta.delta, isMulti, values)
            : moveDelta(selected_items, delta.delta, values);
    });
    return selected_items;
};
const selectDelta = (selected_items, delta, multiple, values) => {
    if (!multiple) {
        return selected_items;
    }
    const selectedSet = new Set(selected_items);
    let latest_index = -1;
    if (selected_items.length >= 1) {
        latest_index = values.indexOf(_.last(selected_items));
    }
    const new_index = latest_index + delta;
    const iterator = delta / Math.abs(delta);
    const new_indices = _.range(latest_index, new_index + iterator, iterator).filter(i => i >= 0 && i < values.length);
    if (selectedSet.size > 1) {
        let index = latest_index - iterator;
        let has_any_prior = false;
        while (index >= 0 && index <= values.length) {
            if (selectedSet.has(values[index])) {
                has_any_prior = true;
                break;
            }
            index -= iterator;
        }
        if (!has_any_prior) {
            index = new_index - iterator;
            while (index >= 0 && index <= values.length) {
                selectedSet.delete(values[index]);
                index -= iterator;
            }
            return Array.from(selectedSet);
        }
    }
    new_indices.map(x => values[x]).forEach(x => selectedSet.add(x));
    let index = new_index + iterator;
    while (index >= 0 && index <= values.length) {
        selectedSet.delete(values[index]);
        index += iterator;
    }
    return Array.from(selectedSet);
};
const moveDelta = (selected_items, delta, values) => {
    let latest_index = -1;
    if (selected_items.length >= 1) {
        latest_index = values.indexOf(_.last(selected_items));
    }
    let new_index = latest_index + delta;
    if (new_index < 0) {
        new_index = 0;
    }
    else if (new_index >= values.length) {
        new_index = values.length - 1;
    }
    return [values[new_index]];
};
//# sourceMappingURL=list-util.js.map